import React from 'react';
import * as cls from './why-voltaware.module.css';
import { Typography } from '../../../ui/components/typography';
import { Section } from '../../../ui/components/section';
import { IMG_PATH } from '../../../constants';

const items = [
  {
    icon: 'ico-certified-and-safe.svg',
    iconAlt: 'Certified and safe',
    title: 'Certified & Safe',
    description: (
      <>
        Meets UK & EU safety standards. Aligned with{' '}
        <strong>IEC 63297:2025</strong>, the first NILM standard.
      </>
    ),
  },
  {
    icon: 'ico-privacy-by-design.svg',
    iconAlt: 'Privacy by design, GDPR',
    title: 'Privacy by Design',
    description:
      'You control your data. Built with GDPR principles from day one.',
  },
  {
    icon: 'ico-email-support.svg',
    title: 'Email Support',
    description: 'Helpful UK team when you need it.',
  },
  {
    icon: 'ico-made-for-uk-and-ireland.svg',
    iconAlt: 'Compatible with UK homes',
    title: 'Made for UK and Irish homes',
    description:
      'Compatible with all UK & Irish homes. Clear £/€ kWh insights, tailored to your tariff.',
  },
];

export const WhyVoltaware = () => {
  return (
    <Section backgroundContrast>
      <Typography as="h1" tag="h2">
        Why Voltaware
      </Typography>

      <ul className={cls.list}>
        {items.map((item, index) => (
          <li key={index}>
            <img
              alt={item.iconAlt || ''}
              src={`${IMG_PATH}/amazon-shop/${item.icon}`}
            />
            <Typography>
              <strong>{item.title}</strong> <span>—</span> {item.description}
            </Typography>
          </li>
        ))}
      </ul>
    </Section>
  );
};
